export default {
  place_categories: []
}
